var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoardPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21352",
    "data-name": "\\uADF8\\uB8F9 21352",
    transform: "translate(-763 -6057)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_27450",
    "data-name": "\\uC0AC\\uAC01\\uD615 27450",
    width: 24,
    height: 24,
    transform: "translate(763 6057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plus",
    d: "M17.938,9.345H10.324V1.7a.5.5,0,0,0-.5-.5.479.479,0,0,0-.476.5V9.345H1.7a.5.5,0,0,0-.5.5.479.479,0,0,0,.5.476H9.345v7.613a.5.5,0,1,0,1.008,0V10.324h7.585a.5.5,0,0,0,.5-.5A.479.479,0,0,0,17.938,9.345Z",
    transform: "translate(765.3 6059.3)",
    fill: "#343a40",
    stroke: "#343a40",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardPlus);
export default __webpack_public_path__ + "static/media/boardPlus.98adc00dc9956d7a1be2ebd56995ba8e.svg";
export { ForwardRef as ReactComponent };